import { useEffect, useRef } from 'react';
import {
  useAssistantPulseQuery,
  useAssistantUserPreferencesQuery,
} from '@/hooks/useAssistantProactive';
import { useAssistantPanel } from './assistantPanelContext';

export function AssistantAutomaticBrief() {
  const { requestBrief } = useAssistantPanel();
  const pulseQuery = useAssistantPulseQuery();
  const preferencesQuery = useAssistantUserPreferencesQuery();
  const requestedKindRef = useRef<string | null>(null);
  const pulse = pulseQuery.data;
  const preferences = preferencesQuery.data;
  const briefKind = pulse === undefined ? null : pulse.brief.kind;
  const shouldPrepare =
    pulse !== undefined &&
    preferences !== undefined &&
    preferences.autoBriefEnabled &&
    pulse.isActive &&
    pulse.brief.status === 'available' &&
    briefKind !== null;

  useEffect(
    function prepareBriefOncePerKind() {
      if (shouldPrepare === false || briefKind === null) {
        return;
      }
      if (requestedKindRef.current === briefKind) {
        return;
      }
      requestedKindRef.current = briefKind;
      requestBrief(briefKind);
    },
    [shouldPrepare, briefKind, requestBrief]
  );

  return null;
}
